import React, { useState } from 'react';
import DecorativeLeaves from '../components/DecorativeLeaves';
import { useMinecraftStatus } from '../context/MinecraftContext';
import './HowToJoinPage.css';

export default function HowToJoinPage() {
  const [copied, setCopied] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const { serverStatus } = useMinecraftStatus();

  const handleCopyIP = () => {
    navigator.clipboard.writeText('thetopia.net');
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <section className="how-to-join-page">
      <DecorativeLeaves config="howToJoin" />
      <div className="join-container">

        <div className="server-ip-section animate-slide-up">
          <div className="ip-status-banner" onClick={handleCopyIP}>
            <div className="ip-status-left">
              <span className={`ip-status-dot ${serverStatus.online ? 'online' : 'offline'}`}></span>
              <span className="ip-status-state">{serverStatus.online ? 'Online' : 'Offline'}</span>
            </div>
            <div className="ip-status-center">
              <span className="ip-status-address">thetopia.net</span>
            </div>
            <div className="ip-status-right">
              {serverStatus.online && (
                <span className="ip-status-players">
                  <i className="mdi mdi-account-multiple"></i>
                  {serverStatus.players.online}
                </span>
              )}
              <span className={`ip-status-copy-hint ${copied ? 'copied' : ''}`}>
                <i className={`mdi ${copied ? 'mdi-check' : 'mdi-content-copy'}`}></i>
              </span>
            </div>
          </div>
          <p className={`copied-confirmation ${copied ? 'visible' : ''}`}>IP Copied to Clipboard!</p>
        </div>

        <div className="connection-steps">
          <h2 className="steps-title animate-slide-up delay-1">Connection Steps</h2>
          <div className="steps-grid">
            <div className="step-card animate-scale-in delay-1">
              <div className="step-number">1</div>
              <h3 className="step-title">Open Minecraft</h3>
              <p className="step-description">
                Launch Minecraft Java Edition on your computer
              </p>
            </div>
            <div className="step-card animate-scale-in delay-2">
              <div className="step-number">2</div>
              <h3 className="step-title">Click "Multiplayer"</h3>
              <p className="step-description">
                Select the Multiplayer option from the main menu
              </p>
            </div>
            <div className="step-card animate-scale-in delay-3">
              <div className="step-number">3</div>
              <h3 className="step-title">Click "Add Server"</h3>
              <p className="step-description">
                Choose "Add Server" to add a new server to your list
              </p>
            </div>
            <div className="step-card animate-scale-in delay-4">
              <div className="step-number">4</div>
              <h3 className="step-title">Paste & Join!</h3>
              <p className="step-description">
                Paste thetopia.net into the server address field and connect to the server!
              </p>
            </div>
          </div>
        </div>

        <div className="requirements-section">
          <h2 className="section-title animate-slide-up delay-6">Requirements</h2>
          <div className="requirements-cards">
            <div className="requirement-card animate-scale-in delay-1">
              <i className="mdi mdi-minecraft requirement-icon"></i>
              <h3>Minecraft Version</h3>
              <p>Java Edition 1.21.11 (Bedrock not supported)</p>
            </div>
            <div className="requirement-card animate-scale-in delay-2">
              <i className="mdi mdi-laptop requirement-icon"></i>
              <h3>Platform</h3>
              <p>PC, Mac, or Linux</p>
            </div>
          </div>
        </div>

        <div className="troubleshooting-section">
          <h2 className="section-title">Troubleshooting</h2>
          <div className="faq-grid">
            {[
              { q: "Can't connect to the server?", a: "Make sure you're using Minecraft Java Edition (not Bedrock) and that you've entered the correct server address: thetopia.net" },
              { q: 'Getting a version mismatch error?', a: 'Update your Minecraft to version 1.21.11. Our goal is to support the most recent Minecraft version available.' },
              { q: 'Server appears offline?', a: "Check our Discord server for status updates and announcements. We'll post there if there's scheduled maintenance or any issues." }
            ].map((item, i) => (
              <div key={i} className={`faq-card ${openFaq === i ? 'open' : ''}`} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <div className="faq-question">
                  <h3 className="faq-question-text">{item.q}</h3>
                  <i className={`mdi mdi-chevron-down faq-chevron ${openFaq === i ? 'open' : ''}`}></i>
                </div>
                <div className="faq-answer-wrapper">
                  <p className="faq-answer">{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="join-cta-section animate-slide-up delay-4">
          <h2 className="join-cta-title">Ready to Play?</h2>
          <p className="join-cta-description">
            Copy the server address and jump right in!
          </p>
          <button className="btn btn-primary btn-large" onClick={handleCopyIP}>
            <i className="mdi mdi-content-copy"></i>
            {copied ? 'Copied!' : 'Copy Server IP'}
          </button>
        </div>
      </div>
    </section>
  );
}
